import type { CSSProperties } from 'react';

type Props = {
  className?: string;
  style?: CSSProperties;
  fullWidth?: boolean;
};

export default function GradientDivider({
  className,
  style,
  fullWidth = false,
}: Props) {
  const defaultClass = fullWidth
    ? 'my-6 h-[2px] w-full mb-6 mt-10'
    : 'mx-auto my-6 h-[2px] w-2/3';

  const combinedClassName = className
    ? `${defaultClass} ${className}`
    : defaultClass;

  return (
    <div
      className={combinedClassName}
      style={{
        background: 'linear-gradient(to right, #58c0ca, #7c3aed)',
        ...style,
      }}
    />
  );
}
